export default [
  "Illegal invocation",
  "Failed to fetch",
  "Failed to load Stripe.js",
  "Non-Error promise rejection captured with value: Object Not Found Matching Id",
  "UnhandledRejection",
  "Cannot read properties of undefined (reading 'identifier')",
  "window.grecaptcha.render is not a function",
  "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
  "HTMLDocument.<anonymous>(sdk)",
  "(sdk)",
  "ResizeObserver loop limit exceeded",
  "top.GLOBALS",
  "HTMLDocument.r(src/helpers)",
  "No reCAPTCHA clients exist",
];
